import React from "react";
import { secondsToHourMinSecs } from "../../utils/utils";
import MPSBarLoader from "../MPSBarLoader";
import Text from "../Text";
import Messages from "../../Shared/Messages";
import "./FloatingVideoCallEnded.scss";

const FloatingVideoCallEnded = ({
  callDuration,
  summaryStatus,
  onClose,
  onTryEnhancedConnection,
}) => (
  <div className="floating-video-call-ended">
    <div className="floating-video-call-ended__icon">
      <i className="fas fa-check" />
    </div>
    <div className="floating-video-call-ended__title">
      <Text content={Messages.video_call_ended} />
    </div>
    <div className="floating-video-call-ended__duration">
      <i className="far fa-clock" />
      {secondsToHourMinSecs(callDuration)}
    </div>

    {summaryStatus === "generating" && (
      <div className="floating-video-call-ended__summary">
        <div className="floating-video-call-ended__summary-label">
          <Text content={Messages.video_call_generating_summary} />
        </div>
        <div className="floating-video-call-ended__summary-hint">
          <Text content={Messages.video_call_summary_opens_hint} />
        </div>
        <div className="floating-video-call-ended__summary-loader">
          <MPSBarLoader width={120} />
        </div>
      </div>
    )}

    {onTryEnhancedConnection && (
      <button
        type="button"
        className="floating-video-call-ended__enhance"
        onClick={onTryEnhancedConnection}
      >
        <Text content={Messages.video_call_try_enhanced_connection} />
      </button>
    )}

    <button
      type="button"
      className="floating-video-call-ended__close"
      onClick={onClose}
    >
      <Text content={Messages.close} />
    </button>
  </div>
);

export default FloatingVideoCallEnded;
